import AiGenerativeTextTitleIcon from '@atlaskit/icon-lab/core/ai-generative-text-title';
import * as React from 'react';

export function SvgAutoTitles() {
  return <AiGenerativeTextTitleIcon label="" testId="ads-refreshed-icon" />;
}
